import common from "../../../module/common";

class SpecialProduct {
    init() {
        this.handleSpecialProductVariationClick();
        this.handleBuyButtonClick();
    }

    handleSpecialProductVariationClick() {
        $('.productFeature.buttonContainer .dropdown .panel.left ul li a').click((event) => {
            this.updateVariationTitleByOption(event.target);
            this.hideErrorNotSelectedVariation(event.target);
            common.dropdownFocusOut();
        });
    }

    handleBuyButtonClick() {
        $('.productFeature.buttonContainer button + .button.medium.order').on('click', (event) => {
            this.hideErrorNotSelectedVariation(event.currentTarget);

            let buyButton = this.getBuyButtonByTarget(event.currentTarget);

            if (!buyButton.data('product')) {
                this.showErrorNotSelectedVariation(event.currentTarget);
                return;
            }

            this.preventMultipleClick(event.currentTarget);

            this.addProductToCart(buyButton.data('product'));
        });
    }

    updateVariationTitleByOption(option) {
        $(option).parents('.dropdown').find('.dropdownButton .specialProductVariationText').text(option.innerText);
        let buyButton = this.getBuyButtonByTarget(option);
        buyButton.data('product', $(option).data('product'));
    }

    showErrorNotSelectedVariation(target) {
        $(target).parents('.productFeature.buttonContainer .dropdown').append(
            "<div class='warning'><img src='/svg/icon-error.svg'><span>Select a version</span></div>"
        );
    }

    hideErrorNotSelectedVariation(target) {
        let warning = $(target).parents('.productFeature.buttonContainer .dropdown').find('.warning');
        if (warning.length) {
            warning.remove();
        }
    }

    preventMultipleClick(element) {
        $(element).off('click').attr('href', "javascript: void(0);");
    }

    hasVariations(element) {
        return $(element).parents('.dropdown').length;
    }

    getBuyButtonByTarget(element) {
        return $(element).parents('.productFeature.buttonContainer').find('.button.medium.order');
    }

    addProductToCart(product) {
        let csrfToken = window.laravel || '';
        let params = {
            product: product,
            csrf_token:csrfToken
        };

        $.post(`${window.location.origin}/?action=cart/addAjax`, params).then(() => {
            window.location.href = `${window.location.origin}/?action=cart`;
        }).catch((error) => {
            console.log(error);
        })
    }
}

$(document).ready(function () {
    let specialProduct = new SpecialProduct();
    specialProduct.init();
});
